<template>
  <div class="login">
    <v-container class="pa-0">
      <v-row>
        <v-col class="pa-0">
          <div class="d-flex flex-column align-center mb-5 mt-sm-5">
            <v-img v-if="isLight" class="hidden-xs-only" contain src="/image/login/top_light.png" max-height="260" max-width="100vw"/>
            <v-img v-if="isLight" class="hidden-sm-and-up" contain src="/image/login/top_light_s.png" max-height="260" max-width="100vw"/>
            <v-img v-if="!isLight && !isContinuePeriod" class="hidden-xs-only" contain src="/image/login/top_mekenpo.png" max-height="260" max-width="100vw"/>
            <v-img v-if="!isLight && isContinuePeriod" class="hidden-xs-only" contain src="/image/login/top_mekenpo_continue.png" max-height="260" max-width="100vw"/>
            <v-img v-if="!isLight" class="hidden-sm-and-up" contain src="/image/login/top_mekenpo_s.png" max-height="260" max-width="100vw"/>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="!isProd">
        <v-col cols="12">
          <v-alert
            type="error"
            width="100%"
          >
            こちらは、検証用ページです。実際のご利用は、下記のURLからお進みください。<br/>
            <a href="https://mekenpo.kenchare.net" class="white--text" style="word-break: break-all;">https://mekenpo.kenchare.net</a><br/><br/>
            <p>※ ↓のログインおよびユーザ登録フォームからはご利用できません。</p>
          </v-alert>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col
          cols="12"
          md="12"
          xl="8" offset-xl="2"
        >
          <v-card
            class="mx-auto"
            outlined
            height="100%"
            elevation="1"
          >
            <v-card-title style="background-color: #ffccd0; color: #ff6673; padding: 0">
              <h5 class="center">お知らせ</h5>
            </v-card-title>
            <v-card-text class="pa-5">
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('operation_process')">
                操作手順
              </v-btn>
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('course_detail')">
                コース説明
              </v-btn>
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('for_new_subscribers')">
                新規に加入された方へ
              </v-btn>
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('about_point')">
                健チャレのポイントについて
              </v-btn>
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('easier_login')">
                簡単にログインするための設定手順
              </v-btn>
              <a v-if="!isLight" style="display: block; padding: 6px 16px;" @click="openPDF('for_smartphone_app')">
                健康チャレンジ専用スマートフォンアプリの使い方
              </a>
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('auto_record')">
                体重・血圧もアプリで連携可能に
              </v-btn>
              <v-btn v-if="!isLight" text color="primary" style="display: block" @click="openPDF('course_pack')">
                おすすめパックについて
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <Participants class="hidden-md-and-up pb-3" :participants="participants" :conParticipants="conParticipants"></Participants>
      <v-row>
        <v-col
          cols="12"
          md="6"
          xl="4" offset-xl="2"
          class="pt-0"
        >
          <v-card
            class="mx-auto"
            outlined
            height="100%"
            elevation="1"
          >
            <v-card-title style="background-color: #02AB98; color:#FFF; padding: 0">
              <h5 class="center">ログインはこちらから</h5>
            </v-card-title>
            <v-card-text class="pa-5">
              <Participants class="hidden-sm-and-down mb-4" :participants="participants" :conParticipants="conParticipants"></Participants>
              <v-row dense class="pb-5">
                <v-col cols="12" v-if="isUserRegistrationEnabled">
                  2026年10月からのキャンペーンでユーザー登録がまだの方
                  <div class="center">
                    <v-btn color="secondary" align="center" @click="signUp">
                      ユーザー登録はこちら
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" v-if="!isUserRegistrationEnabled">
                  <v-alert type="warning">
                    ユーザー登録の受付は終了しました
                  </v-alert>
                </v-col>
              </v-row>
              <validation-observer ref="observer">
                <v-row dense>
                  <v-col cols="12">
                    <div class="mb-4">
                      ユーザー登録済みの方は、こちらからログインしてください。
                    </div>
                    <v-alert
                      v-if="alert"
                      border="left"
                      colored-border
                      type="error"
                      elevation="2"
                      style="font-size: 90%"
                    >
                      {{ error }}
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <v-subheader style="height: 14px" class="text-caption" >
                      区分を選択
                    </v-subheader>
                  </v-col>
                  <v-btn-toggle
                    v-model="loginInfo.userClassification"
                    mandatory
                    color="primary"
                    style="margin: 0 auto"
                    class="mb-7"
                  >
                    <v-btn value="本人" width="150" height="35" class="">被保険者（本人）</v-btn>
                    <v-btn value="被扶養者" width="150" height="35" class="">被扶養者（家族）</v-btn>
                  </v-btn-toggle>
                </v-row>
                <v-form @submit.prevent="signIn" ref="form">
                  <v-row dense>
                    <v-col cols="4">
                      <validation-provider
                        name="記号"
                        rules="required|max:3|numeric"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="loginInfo.userSymbolId"
                          :error-messages="errors"
                          label="記号"
                          type="tel"
                          name="symbol-id"
                          autocomplete="symbol-id"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col class="pt-3 pl-2" cols="1">
                      －
                    </v-col>
                    <v-col cols="7">
                      <validation-provider
                        name="番号"
                        rules="required|max:7|numeric"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="loginInfo.userNumberId"
                          :error-messages="errors"
                          label="番号"
                          type="tel"
                          name="number-id"
                          autocomplete="number-id"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <validation-provider
                        name="パスワード"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="loginInfo.password"
                          :append-icon="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :error-messages="errors"
                          :type="isShowPassword ? 'text' : 'password'"
                          hint="英小文字・英大文字・数字・記号の4種を含め、8文字以上（14文字以上推奨）"
                          @click:append="isShowPassword = !isShowPassword"
                          label="パスワード"
                          name="password"
                          autocomplete="off"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="loginInfo.userClassification=='被扶養者'">
                    <v-col cols="12">
                      <v-subheader style="height: 14px" class="text-caption">
                        生年月日
                      </v-subheader>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="loginInfo.userClassification=='被扶養者' && !isMobile">
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(年)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="loginInfo.birthYear"
                          :items="birthSelectList.year"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(月)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="loginInfo.birthMonth"
                          :items="birthSelectList.month"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(日)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="loginInfo.birthDay"
                          :items="birthSelectList.day"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="loginInfo.userClassification=='被扶養者' && isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(年)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="loginInfo.birthYear"
                          :items="birthSelectList.year"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="loginInfo.userClassification=='被扶養者' && isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(月)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="loginInfo.birthMonth"
                          :items="birthSelectList.month"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="loginInfo.userClassification=='被扶養者' && isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(日)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="loginInfo.birthDay"
                          :items="birthSelectList.day"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="loginInfo.userClassification=='被扶養者'">
                    <v-col cols="12">
                      <v-subheader style="height: 14px" class="text-caption">
                        性別
                      </v-subheader>
                    </v-col>
                    <v-btn-toggle
                      v-model="loginInfo.gender"
                      mandatory
                      color="primary"
                      style="margin: 0 auto"
                    >
                      <v-btn width="100" height="30" value="male">男性</v-btn>
                      <v-btn width="100" height="30" value="female">女性</v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <v-checkbox
                    v-model="isCookieSave"
                    label="健康保険 記号－番号をブラウザに保存"
                    class="cookieCheckbox"
                    hide-details="auto"
                  ></v-checkbox>
                  <div class="center">
                    <v-btn
                      type="submit"
                      color="primary"
                      class="mt-8"
                      :loading="isLoading"
                    >
                      ログイン
                    </v-btn>
                  </div>
                </v-form>
              </validation-observer>
              <div class="authlinks" align="center">
                <v-btn text color="primary" @click="forgot">
                  パスワードを忘れた方
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="6"
          xl="4"
          class="pt-0"
        >
          <v-row>
            <v-col>
              <v-card
                outlined
                elevation="1"
              >
                <v-card-title style="background-color: #EDEDED; padding: 0">
                  <h5 class="center">スマートフォンからアクセスする</h5>
                </v-card-title>
                <v-card-text class="pa-5">
                  <v-row dense>
                    <v-col cols="12">
                      <div class="mb-4">
                        お使いのスマートフォンから下記のURLにアクセスしご利用ください。
                      </div>
                      <div class="mb-4">
                        <p>{{kehcnareUrl}}</p>
                      </div>
                      <vue-qrcode :value="kehcnareUrl" tag="img"></vue-qrcode>
                      <p>QRコードリーダーでURLを読み込みした後、下記のブラウザでご利用ください。</p>
                      <ul>
                        <li>Apple Safari</li>
                        <li>Google Chrome</li>
                      </ul>
                      </v-col>
                    </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  v-if="!isLight"
                >
              <v-card
                outlined
                elevation="1"
              >
                <v-card-title style="background-color: #EDEDED; padding: 0">
                  <h5 class="center">記号－番号の間違いに注意！</h5>
                </v-card-title>
                <v-card-text class="pa-5">
                  <p class="mb-0">健康マイポータルや「資格確認書」を参考に、ご自身の健康保険 記号ー番号を入力してください。</p>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card
                v-if="supportdesk"
                outlined
                elevation="1"
              >
                <v-card-title style="background-color: #EDEDED; padding: 0">
                  <h5 class="center">サポートデスク</h5>
                </v-card-title>
                <v-card-text class="pa-5">
                  <p style="white-space:pre-wrap;" v-text="supportdesk"></p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
import Vue from 'vue'
import GraphqlAPI from '../../utils/GraphqlAPI'
import AmplifyEventBus from './AmplifyEventBus'
import { Auth, I18n } from 'aws-amplify'
import { translate } from '@/i18n'
import { required, max, numeric } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'
import VueQrcode from '@chenfengyuan/vue-qrcode'
const Participants = () => import('./Participants.vue')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('required', required)
extend('max', max)
extend('numeric', numeric)

const getCampaignUserQuery = (campaignId) => `
  query getCampaignUser {
    getCampaignUser(campaign_id: "${campaignId}") {
      id
      course
      custom_objective_list {
        course_id
        custom_objective
      }
    }
  }
`
const getCampaignUserCourse = async (campaignId) => {
  const { data: { getCampaignUser: data } } = await GraphqlAPI(getCampaignUserQuery(campaignId))
  return data
}

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

export default Vue.extend({
  name: 'HCSignIn',
  props: ['signInConfig'],
  components: {
    ValidationProvider,
    ValidationObserver,
    Participants,
    VueQrcode
  },
  data () {
    return {
      loginInfo: {
        userClassification: '本人',
        userSymbolId: '',
        userNumberId: '',
        password: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        gender: ''
      },
      isShowPassword: false,
      birthSelectList: {
        year: [],
        month: [],
        day: []
      },
      isCookieSave: false,
      isLoading: false,
      error: '',
      logger: {},
      alert: false,
      campaignList: [],
      supportdesk: '',
      participants: '',
      conParticipants: '',
      isContinuePeriod: false,
      isUserRegistrationEnabled: false // ユーザ登録可能
    }
  },
  computed: {
    options () {
      const defaults = {
        header: 'ログイン',
        username: '',
        isSignUpDisplayed: true
      }
      return Object.assign(defaults, this.signInConfig || {})
    },
    getCampaign () {
      return this.$store.getters.getCampaign
    },
    kehcnareUrl () {
      return location.href
    },
    // 運用テストかどうか（健チャレLight版）
    isLight () {
      return process.env.VUE_APP_IS_LIGHT
    },
    isProd () {
      return process.env.VUE_APP_DISP_STAGE_NAME === 'prod'
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    'loginInfo.birthYear' () {
      this.getBirthDaySelectList()
    },
    'loginInfo.birthMonth' () {
      this.getBirthDaySelectList()
    }
  },
  created () {
    // 被扶養者は19歳～75歳が対象
    const todayYear = dayjs().year()
    const yearSelectList = []
    for (let y = todayYear - 76; y <= todayYear - 19; y++) {
      yearSelectList.push({ text: y + '年', value: y })
    }
    this.birthSelectList.year = yearSelectList.reverse()
    for (let m = 1; m <= 12; m++) {
      this.birthSelectList.month.push({ text: m + '月', value: m })
    }
    this.loginInfo.birthYear = this.birthSelectList.year[0].value
    this.loginInfo.birthMonth = 1
    this.loginInfo.birthDay = 1
  },
  mounted () {
    this.getCampaignJson()
    this.getSupportdeskJson()
    // cookie情報の取得
    const cookiesArray = document.cookie.split(';')
    for (var cookie of cookiesArray) {
      var splitCookie = cookie.split('=')
      if (splitCookie[0].trim() === 'kenchare') {
        this.isCookieSave = true
        var cookieValues = decodeURIComponent(splitCookie[1]).split('-')
        this.loginInfo.userClassification = cookieValues[0]
        this.loginInfo.userSymbolId = cookieValues[1]
        this.loginInfo.userNumberId = cookieValues[2]
        this.loginInfo.birthYear = Number(cookieValues[3])
        this.loginInfo.birthMonth = Number(cookieValues[4])
        this.loginInfo.birthDay = Number(cookieValues[5])
        this.loginInfo.gender = cookieValues[6]
      }
    }
  },
  methods: {
    // cloudfront→S3からjsonファイルのキャンペーン参加者人数を取得
    getCampaignJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/campaign_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const campaignList = this.response
            const targetCampaign = campaignList.find(item => !item.is_continuity)
            if (targetCampaign) {
              me.participants = targetCampaign.participants
              me.isUserRegistrationEnabled = dayjs(targetCampaign.signup_deadline_date, 'YYYY-MM-DD').add(1, 'days') > dayjs()
            }
            const conTargetCampaign = campaignList.find(item => item.is_continuity)
            if (conTargetCampaign) {
              me.conParticipants = conTargetCampaign.participants
              // トップ画像の表示分け
              me.isContinuePeriod = dayjs(conTargetCampaign.start, 'YYYY-MM-DD') < dayjs()
            }
          }
        }
      }
    },
    // cloudfront→S3からjsonファイルのサポートデスク情報を取得(手動でS3にファイルを格納する)
    getSupportdeskJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/supportdesk.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const supportdeskObj = this.response
            me.supportdesk = supportdeskObj.description
          }
        }
      }
    },
    getBirthDaySelectList () {
      const targetDate = `${this.loginInfo.birthYear}-${this.loginInfo.birthMonth}-01`
      const maxDay = dayjs(targetDate, 'YYYY-MM-DD').endOf('month').date()
      this.birthSelectList.day = []
      for (let d = 1; d <= maxDay; d++) {
        this.birthSelectList.day.push({ text: d + '日', value: d })
      }
    },
    async signIn () {
      this.alert = false
      this.isLoading = true
      const isValidateError = await this.$refs.observer.validate()
      if (!isValidateError) {
        this.alert = true
        this.error = '入力内容にエラーがあります。確認してください。'
        this.isLoading = false
        return false
      }
      if (this.isCookieSave) {
        const loginData = this.loginInfo.userClassification + '-' +
          this.loginInfo.userSymbolId + '-' +
          this.loginInfo.userNumberId + '-' +
          this.loginInfo.birthYear + '-' +
          this.loginInfo.birthMonth + '-' +
          this.loginInfo.birthDay + '-' +
          this.loginInfo.gender
        const maxAge = 604800 // 1週間（秒）
        document.cookie = 'kenchare=' + encodeURIComponent(loginData) + ';max-age=' + maxAge
      } else {
        document.cookie = 'kenchare=;max-age=0'
      }
      let preferredUser = ''
      if (this.loginInfo.userClassification === '本人') {
        preferredUser = `${this.loginInfo.userSymbolId}-${this.loginInfo.userNumberId}`
      } else {
        const birthMonth = `0${this.loginInfo.birthMonth}`.slice(-2)
        const birthDay = `0${this.loginInfo.birthDay}`.slice(-2)
        const birtDate = `${this.loginInfo.birthYear}${birthMonth}${birthDay}`
        preferredUser = `${this.loginInfo.userSymbolId}-${this.loginInfo.userNumberId}_${birtDate}_${this.loginInfo.gender}`
      }
      Auth.signIn(preferredUser, this.loginInfo.password)
        .then(async (data) => {
          this.$log.info('sign in success')
          if (data.challengeName === 'SMS_MFA' || data.challengeName === 'SOFTWARE_TOKEN_MFA') {
            AmplifyEventBus.$emit('localUser', data)
            return AmplifyEventBus.$emit('authState', 'confirmSignIn')
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            AmplifyEventBus.$emit('localUser', data)
            return AmplifyEventBus.$emit('authState', 'requireNewPassword')
          } else if (data.challengeName === 'MFA_SETUP') {
            AmplifyEventBus.$emit('localUser', data)
            return AmplifyEventBus.$emit('authState', 'setMfa')
          } else {
            this.$store.dispatch('setIsAuthenticated', true)
            this.$store.dispatch('setUser', data)
            this.$store.dispatch('setEmailVerified', data.attributes.email_verified)
            await this.$store.dispatch('initCampaign')
            await this.fetchUserCourseData()
            if (this.getCampaign.is_app_challenge) {
              await this.featchAppEntryStatus()
            }
            const appStatus = this.$store.getters.getAppEntryStatus
            // メールアドレス認証未完了
            if (!data.attributes.email_verified) {
              this.$router.push('/email')
            // コース選択済みorアプリチャレンジ申込み中
            } else if (this.$store.getters.getRegisteredCourse || appStatus === 'Temporary' || appStatus === 'Waiting' || appStatus === 'Completion') {
              // リダイレクト指定があればリダイレクトする
              if (this.$route.query.redirect) {
                this.$router.push(this.$route.query.redirect)
              } else {
                this.$router.push({
                  name: 'result',
                  params: { referer: 'login' }
                })
              }
            } else {
              this.$router.push('/course')
            }
          }
        })
        .catch((e) => {
          this.$log.debug('----error signin----:', e)
          if (e.code && e.code === 'UserNotConfirmedException') {
            AmplifyEventBus.$emit('localUser', { username: this.options.username })
            AmplifyEventBus.$emit('authState', 'confirmSignUp')
            return false
          } else {
            this.setError(e)
          }
        })
    },
    forgot () {
      return AmplifyEventBus.$emit('authState', 'forgotPassword')
    },
    signUp () {
      AmplifyEventBus.$emit('authState', 'signUp')
    },
    setError (e) {
      this.isLoading = false
      const errorMessage = I18n.get(e.message || e)
      this.$log.debug(errorMessage)
      if (errorMessage === 'Incorrect username or password.') {
        this.error = `${translate('auth.errors.incorrectIdOrPass')}`
      } else if (errorMessage === 'User does not exist.') {
        this.error = `${translate('auth.errors.userNotRegistered')}`
      } else if (errorMessage === 'Password attempts exceeded') {
        this.error = `${translate('auth.errors.limitExceededException')}`
      } else if (errorMessage === 'PostAuthentication failed with error .') {
        this.error = `${translate('auth.errors.userLambdaValidation')}`
      } else {
        this.error = `${translate('auth.errors.unexpectedError')}`
      }
      this.alert = true
    },
    async fetchUserCourseData () {
      try {
        const getCampaignUserResult = await getCampaignUserCourse(this.getCampaign.id)
        const customObjectiveList = getCampaignUserResult.custom_objective_list
        if (customObjectiveList.length > 0) {
          this.$store.dispatch('setRegisteredCourse', true)
        } else {
          this.$store.dispatch('setRegisteredCourse', false)
        }
      } catch (e) {
        this.setError(e)
        this.$log.debug(e)
      }
    },
    async featchAppEntryStatus () {
      try {
        const appEntryStatus = await checkAppUserStatus(this.getCampaign.id)
        this.$store.dispatch('setAppEntryStatus', appEntryStatus)
      } catch (e) {
        this.$log.debug(e)
      }
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }
  }
})
</script>

<style scoped lang="scss">
.login {
  .center {
    margin: 5px auto;
    text-align: center;
  }
}
.authlinks {
  display: block;
  margin-top:10px;
}
// button.ma-2.clbtn-main.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
//   background-color: #8AD0B0 !important;
// }
// button.ma-2.clbtn-main.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default::before {
//   opacity: 0 ;
// }
// button.ma-2.clbtn-dependent.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
//   background-color: #ffed66 !important;
// }
// button.ma-2.clbtn-dependent.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default::before {
//   opacity: 0 ;
// }
</style>
